import { platform } from "@tauri-apps/plugin-os";
import tauri from "lib/tauri";

export function isMacOS(): boolean {
  if (typeof navigator === "undefined") return false;
  if (tauri.enabled) {
    try {
      return platform() === "macos";
    } catch {
      return false;
    }
  }
  return /Mac/i.test(navigator.userAgent);
}

/** System modifier + K, e.g. `⌘K` on macOS or `Ctrl+K` elsewhere. */
export function modKeyShortcut(): string {
  return isMacOS() ? "⌘K" : "Ctrl+K";
}

export function globalSearchPlaceholder(wideViewport: boolean): string {
  const shortcut = modKeyShortcut();
  if (!wideViewport) {
    return `Search (${shortcut})`;
  }
  return `Search players, tournaments, groups... (${shortcut})`;
}
